export function isPageAnimating() {
	return (
		document.querySelectorAll(
			".animate-bottom-enter, .animate-top-enter, .animate-left-enter, .animate-right-enter",
		).length > 0
	);
}
